// extracted by mini-css-extract-plugin
export var aboveInput = "_nt-0";
export var actionButton = "_nt-5";
export var actionButtonContainer = "_nt-1";
export var actionIcon = "_nt-6";
export var aiInfoContainer = "_nt-2";
export var attachmentWrapper = "_nt-7";
export var bold = "_nt-3";
export var checkIcon = "_nt-8";
export var clickingRecipientBar = "_nt-11";
export var commentThreadSwitch = "_nt-a";
export var draftImage = "_nt-b";
export var draftImageContainer = "_nt-c";
export var draftImages = "_nt-e";
export var editButton = "_nt-g";
export var editor = "_nt-f";
export var editorContainer = "_nt-y";
export var editorErrorTooltipWrapper = "_nt-9";
export var headerDivider = "_nt-h";
export var icon = "_nt-i";
export var info = "_nt-j";
export var internal = "_nt-n";
export var internalDivider = "_nt-k";
export var internalMessage = "_nt-l";
export var messageInputCard = "_nt-m";
export var messageInputForm = "_nt-o";
export var messageInputFormInternal = "_nt-p";
export var options = "_nt-q";
export var publicMessageCustomer = "_nt-s";
export var publicMessageMerchant = "_nt-r";
export var removeImageButton = "_nt-d";
export var replyButtons = "_nt-t";
export var showSignatureButton = "_nt-u";
export var spinner = "_nt-v";
export var verticalButtonDivider = "_nt-4";
export var visibilitySelector = "_nt-w";
export var warning = "_nt-x";
export var wrappingText = "_nt-z";
export var writingInternalNoteTopBorder = "_nt-10";